module.exports = __webpack_public_path__ + "static/media/dish13.bbb4c646.jpg";